<template>
  <div id="p-zj" v-if="currentLec">
    <div class="h11 position-relative" id="p-story-1" style="top: -66px;"></div>
    <div class="b-title d-flex align-items-center">
      项目专家
    </div>
    <div class="p-zj-content position-relative" v-if="advSubLecturers">
      <img class="position-absolute right-img" src="/static/img/pro/cheng.png" alt="">
      <img class="position-absolute text-img" src="/static/img/pro/text.png" alt="">
      <div class="zj-info" >
        <div class="zj-big-ava bg-white" v-if="avatorUrl"
             :style="{'background-image':'url('+avatorUrl+')'}">
<!--          <div class=" guanzhu-btn cursor-pointer">关注</div>-->
        </div>

        <p class="zj-name w-100 text-center line-16 mt-3 mb-20 text-white van-ellipsis">{{currentLec.userInfo.name?currentLec.userInfo.name:''}}
          <span class="zj-rank  ml-3">{{currentLec.userInfo.nickname?currentLec.userInfo.nickname:''}}</span></p>
        <p class="zj-desc mb-1 line-24 font-12 text-white van-multi-ellipsis--l3">
          {{currentLec.userInfo.introduction?currentLec.userInfo.introduction:''}}
        </p>
      </div>
      <teacher-course :teacherList=anthorLearders type="advLeader" @getUserId="changeLeader"></teacher-course>
    </div>
  </div>
</template>

<script>
  import TeacherCourse from '@/components/teacherCourse'
  import {mapState} from "vuex";
  export default {
    name: "advExpert",
    data() {
      return {
        currentLec: {},
        anthorLearders: [],
        lecturerList: [],
        avatorUrl: '',
      }
    },
    props: [
      'advSubLecturers'
    ],
    created() {
      this.lecturerList = this.advSubLecturers;
      this.getCurrentLec(this.advSubLecturers);
    },
    components: {
      TeacherCourse
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl
      })
    },

    watch: {
      // advSubLecturers(newValue, oldValue) {
      //   this.currentLec = newValue[0];
      //   console.log(this.currentLec)
      //   this.anthorLearders = newValue;
      //   if (this.currentLec && this.currentLec.cover) {
      //     this.avatorUrl = this.getAvator(this.currentLec.cover);
      //   } else if (this.currentLec && this.currentLec.userInfo) {
      //     this.avatorUrl = this.getAvator(this.currentLec.userInfo.avatarUrl);
      //   }
      // },
    },
    methods: {
      getCurrentLec(newValue) {
        this.currentLec = newValue[0];
        console.log(this.currentLec)
        this.anthorLearders = newValue;
        if (this.currentLec && this.currentLec.cover) {
          this.avatorUrl = this.getAvator(this.currentLec.cover);
        } else if (this.currentLec && this.currentLec.userInfo) {
          this.avatorUrl = this.getAvator(this.currentLec.userInfo.avatarUrl);
        }
      },
      changeLeader(e) {
        for (let v of this.advSubLecturers) {
          if (v.userId === e) {
            this.currentLec = v;
            if (this.currentLec && this.currentLec.cover) {
              this.avatorUrl = this.getAvator(this.currentLec.cover);
            } else if (this.currentLec && this.currentLec.userInfo) {
              this.avatorUrl = this.getAvator(this.currentLec.userInfo.avatarUrl);
            }
          }
        }
      },
      getAvator: function (value) {
        let uploadresUrl = '//res.aqjsjx.com.cn/';
        let img = '/static/img/pro/userDefault.png';
        let avatarUrl = value;
        if (avatarUrl) {
          if (avatarUrl.indexOf('http') < 0) {
            img = uploadresUrl + avatarUrl;
          } else {
            img = avatarUrl;
          }
        }

        return img;
      }
    }
  }
</script>

<style>
  .zj-info .zj-big-ava .guanzhu-btn {
    border-radius: .5rem !important;
    background: #01adf7;
    padding: .5rem .75rem;
    line-height: .875rem;
    font-size: .875rem;
    color: #ffffff !important;
  }
</style>
